<template>
    <div class="person-left-tab">
        <div class="tab-item" v-for="item in list" :key="item.field">
            <a-divider orientation="left">{{ item.title }}</a-divider>

            <div
                :class="['subtitle', { active: activeTab === sub.field }]"
                v-for="sub in item.children"
                :key="sub.field"
                @click="changeTab(sub.field)"
            >
                {{ sub.title }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            required: true,
            default: () => []
        }
    },
    data() {
        return {
            activeTab: ''
        };
    },
    mounted() {
        if (this.list.length && this.list[0]?.children.length) {
            const text = this.list[0].children[0].field;
            this.changeTab(text);
        }
    },
    methods: {
        changeTab(field) {
            this.activeTab = field;
            this.$emit('change', field);
        }
    }
};
</script>

<style lang="scss" scoped>
.person-left-tab {
    width: 192px;
    padding: 14px 0;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(13, 24, 41, 0.05);
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    height: fit-content;

    .tab-item {
        margin-bottom: 16px;

        :deep(.ant-divider) {
            margin: 0 0 16px;
            .ant-divider-inner-text {
                color: #666666;
                font-size: 14px;
                line-height: 20px;
            }
        }
    }

    .subtitle {
        margin: 0 8px 4px;
        padding-left: 32px;
        font-size: 16px;
        color: #333333;
        height: 32px;
        line-height: 32px;
        cursor: pointer;

        &.active {
            color: #fff;
            background: #005299;
            border-radius: 2px;
            font-weight: 600;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }
}
</style>
